<!-- 用户列表 -->
<template>
    <div>
        <div class="header">
            <Input class="w300 mr24 mb24" type="text" v-model="storePrams.keywords" placeholder="搜索用户名称、手机号"></Input>
            <Input class="w200 mr24 mb24" type="text" v-model="storePrams.qrcode_number" placeholder="通过溯源码编码查询"></Input>
            <Select class="mr24 mb24 w200" v-model="storePrams.is_after" clearable filterable placeholder="是否有售后">
                <Option v-for="item in afterList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Button class="theme-bc mb24 theme-default-color" icon="ios-search" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <Button class="theme-bc mb24 theme-default-color" icon="md-add-circle" @click="goModal">新增用户</Button>
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button v-if="row.after_sales_count >= 1" type="success" ghost @click="goAfterSales(row)">售后信息</Button>
                        <div v-else style="width: 88px;"></div>
                        <Button type="primary" ghost @click="goModal(row)">编辑</Button>
                        <Button type="error" ghost @click="goDel(row)">删除</Button>
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="600" :mask-closable="false">
            <Form :model="formData" label-position="right" :label-width="150">
                <FormItem label="用户名称：">
                    <Input class="w300" type="text" v-model="formData.name" placeholder="请输入用户名称"></Input>
                </FormItem>
                <FormItem label="用户手机号：">
                    <Input class="w300" type="text" v-model="formData.phone" placeholder="请输入用户手机号"></Input>
                </FormItem>
                <FormItem label="备注：">
                    <Input class="w300" type="textarea" v-model="formData.desc" placeholder="请输入备注"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitModal">确定</Button>
            </div>
        </Modal>
        <!-- 售后信息 -->
        <Modal v-model="infoModal" title="售后信息" width="700" :mask-closable="false">
            <div class="info-div">
                <div class="info-left">
                    <img class="info-img" src="@/assets/userlist/after-sales-info.png" alt="" @click="goUser(formLeft)">
                    <div class="info-left-title">用户信息</div>
                    <div class="info-left-text">用户名称: {{formLeft.name}}</div>
                    <div class="info-left-text">用户手机号: {{formLeft.phone}}</div>
                    <div class="info-left-text">创建时间: {{formLeft.created_at}}</div>
                    <div>备注信息: {{formLeft.desc}}</div>
                </div>
                <div class="info-right">
                    <div v-for="(item, index) in formRight" :key="index" class="card-div">
                        <img class="info-img" src="@/assets/userlist/after-sales-info.png" alt="" @click="openProduct(item)">
                        <div class="info-right-title">产品信息</div>
                        <div class="info-right-text">
                            溯源码编码: {{item.qrcode_number}}
                            <span v-if="item.qrcode">({{item.qrcode.product ? item.qrcode.product.product_name : ''}})</span>
                        </div>
                        <div class="info-right-txt">
                            <div>质保期: {{item.days}}天</div>
                            <div>激活时间: {{item.active_date}}</div>
                        </div>
                        <div v-for="(e, i) in item.json_text" :key="i" class="info-json-text">
                            <div class="json-text-title">{{e.title_name}}:</div>
                            <div v-if="e.type == 1 || e.type == 3 || e.type == 4 || e.type == 5 || e.type == 6">{{e.input_value}}</div>
                            <div v-if="e.type == 2">{{e.input_value.join('*')}}</div>
                            <div v-if="e.type == 7">
                                <img v-for="(it, j) in e.show_upload" :key="j" :src="it" alt="" class="json-text-img">
                            </div>
                            <div v-if="e.type == 8">
                                <video v-if="e.show_upload" :src="e.show_upload" class="json-text-video"></video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 售后信息编辑 -->
        <Modal v-model="productModal" title="售后信息编辑" width="600" :mask-closable="false">
            <Form :model="formProduct" label-position="right" :label-width="150">
                <div class="product-title">基础信息</div>
                <FormItem label="激活日期">
                    <DatePicker class="w300" :value="formProduct.active_date" type="date" placeholder="点击选择时间" @on-change="changeActiveDate"></DatePicker>
                </FormItem>
                <FormItem label="质保期">
                    <Input class="w300" type="text" v-model="formProduct.days" placeholder="请输入质保期"><span slot="append">天</span></Input>
                </FormItem>
                <template v-if="formProduct.json_text.length">
                    <div class="product-title">填写信息</div>
                    <FormItem v-for="(item, index) in formProduct.json_text" :key="index" :label="item.title_name">
                        <Input v-if="item.type == 1" v-model="item.input_value" type="text" :placeholder="item.prompt_text"></Input>
                        <CheckboxGroup v-if="item.type == 2" v-model="item.input_value">
                            <template v-if="item.type_val">
                                <Checkbox v-for="(e, i) in item.type_val.split('*')" :key="i" :label="e"></Checkbox>
                            </template>
                        </CheckboxGroup>
                        <Input v-if="item.type == 3" type="textarea" v-model="item.input_value" :placeholder="item.prompt_text"></Input>
                        <RadioGroup v-if="item.type == 4" v-model="item.input_value">
                            <template v-if="item.type_val">
                                <Radio v-for="(e, i) in item.type_val.split('*')" :key="i" :label="e"></Radio>
                            </template>
                        </RadioGroup>
                        <Select v-if="item.type == 5" :placeholder="item.prompt_text" v-model="item.input_value" clearable>
                            <template v-if="item.type_val">
                                <Option v-for="(e, i) in item.type_val.split('*')" :value="e" :key="i">{{ e }}</Option>
                            </template>
                        </Select>
                        <DatePicker v-if="item.type == 6" type="date" :value="item.input_value" :placeholder="item.prompt_text" style="width: 100%;"></DatePicker>
                        <div v-if="item.type == 7" class="img-divs">
                            <div class="img-div" @click="openModal(item, 'img')">
                                <img src="@/assets/img.png" alt="" class="img-div-icon">
                            </div>
                            <div v-for="(e, i) in item.show_upload" :key="i">
                                <div class="upload-div">
                                    <Icon class="upload-del" size="20" type="ios-close-circle" color="#f00" @click="delImg(item, i)"/>
                                    <img class="upload-img" :src="e">
                                </div>
                            </div>
                            <div class="img-txt">最多上传10张</div>
                        </div>
                        <div v-if="item.type == 8" class="img-divs">
                            <div class="img-div" @click="openModal(item, 'video')">
                                <img src="@/assets/video.png" alt="" class="img-div-icon">
                            </div>
                            <div v-if="item.show_upload" class="upload-div">
                                <Icon class="upload-del" size="20" type="ios-close-circle" color="#f00" @click="delVideo(item)"/>
                                <video class="upload-img" :src="item.show_upload"></video>
                            </div>
                            <div class="img-txt">最大上传50MB视频</div>
                        </div>
                    </FormItem>
                </template>
            </Form>
            <div slot="footer">
                <Button @click="cancelProductModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitProductModal">确定</Button>
            </div>
        </Modal>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal" :select="select" :select_type="select_type" @change="costPlannedAmountChange"></pictureLibrary>
    </div>
</template>

<script>
import { customer, customer_save, customer_del, customer_sales, customer_sales_save } from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    data() {
        return {
            select_value: "",
            select_data: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
                qrcode_number: "",
                is_after: 0,
            },
            total: 0,
            afterList: [
                { id: 0, name: "全部" },
                { id: 1, name: "有售后" },
                { id: 2, name: "暂无售后" },
            ],
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "用户名称", key: "name", align: "center" },
                { title: "用户手机号", key: "phone", align: "center" },
                { title: "备注", key: "desc", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "300px" },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                name: "",
                phone: "",
                desc: "",
            },
            infoModal: false,
            formLeft: {
                id: "",
                name: "",
                phone: "",
                created_at: "",
                desc: "",
            },
            formRight: [],
            productModal: false,
            formProduct: {
                id: "",
                active_date: "",
                days: "",
                json_text: [],
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if(this.select_value == 'img'){
                for (var i = 0; i < param1.length; i++) {
                    this.select_data.show_upload.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.select_data.upload_value.push(param2[i]);
                }
            }else if(this.select_value == 'video'){
                for (var i = 0; i < param1.length; i++) {
                    this.select_data.show_upload = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.select_data.upload_value = param2[i];
                }
            }
        },
        openModal(item, index) {
            this.select_data = item;
            this.select_value = index;
            if(this.select_value == 'video'){ 
                this.select_type = 'video';
            }else{ 
                this.select_type = 'image';
                if(this.select_data.show_upload == null){
                    this.select_data.show_upload = [];
                }
                if(this.select_data.upload_value == null){
                    this.select_data.upload_value = [];
                }
            }
            this.switch_modal = true;
        },
        getList() {
            customer(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goModal(row){
            if(row.id){
                // 编辑
                this.modalTitle = "编辑用户";
                this.formData.id = row.id;
                this.formData.name = row.name;
                this.formData.phone = row.phone;
                this.formData.desc = row.desc;
            }else {
                // 新增 
                this.modalTitle = "新增用户";
                this.formData.id = "";
                this.formData.name = "";
                this.formData.phone = "";
                this.formData.desc = "";
            }
            this.modals = true;
        },
        goUser(row){
            if(row.id){
                // 编辑
                this.modalTitle = "编辑用户";
                this.formData.id = row.id;
                this.formData.name = row.name;
                this.formData.phone = row.phone;
                this.formData.desc = row.desc;
            }
            this.infoModal = false;
            this.modals = true;
        },
        cancelModal(){
            this.modals = false;
        },
        submitModal(){
            customer_save(this.formData).then(res=>{
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        goDel(row){
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    customer_del({ id: row.id }).then(res=>{
                        this.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
        getCustomerSales(id){
            customer_sales({ id: id }).then(res=>{
                this.formRight = res.data.data;
                this.infoModal = true;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        goAfterSales(row){
            this.formLeft.id = row.id;
            this.formLeft.name = row.name;
            this.formLeft.phone = row.phone;
            this.formLeft.created_at = row.created_at;
            this.formLeft.desc = row.desc;
            this.getCustomerSales(row.id)
        },
        openProduct(item){
            this.formProduct.id = item.id;
            this.formProduct.active_date = item.active_date;
            this.formProduct.days = item.days;
            this.formProduct.json_text = item.json_text;
            this.productModal = true;
        },
        cancelProductModal(){
            this.productModal = false;
        },
        submitProductModal(){
            customer_sales_save(this.formProduct).then(res=>{
                this.productModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        changeActiveDate(e){
            if(e){
                this.formProduct.active_date = e;
            }else {
                this.formProduct.active_date = "";
            }
        },
        // 删除图片
        delImg(item, index) {
            item.show_upload.splice(index, 1);
            item.upload_value.splice(index, 1);
        },
        // 删除视频
        delVideo(item){
            item.show_upload = '';
            item.upload_value = '';
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.text-align-right {
    text-align: right;
}
.info-div {
    display: flex;
    height: 500px;
    min-height: 500px;
    max-height: 500px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #484E66;
}
.info-left {
    width: 222px;
    margin-right: 24px;
    background: rgba(255,255,255,0);
    border-radius: 10px;
    border: 1px solid #999999;
    position: relative;
    padding: 12px;
}
.info-img {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
}
.info-right {
    flex: 1;
    height: 500px;
    min-height: 500px;
    max-height: 500px;
    overflow: auto;
}
.info-left-title {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 16px;
    color: #484E66;
    text-align: center;
    margin-bottom: 30px;
}
.info-left-text {
    margin-bottom: 10px;
}
.card-div {
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #999999;
    position: relative;
    padding: 12px 48px 12px 12px;
    margin-bottom: 12px;
}
.card-div:last-child {
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #999999;
    position: relative;
    padding: 12px 48px 12px 12px;
    margin-bottom: 0px;
}
.info-right-title {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 16px;
    color: #484E66;
    margin-bottom: 20px;
}
.info-right-text {
    margin-bottom: 10px;
}
.info-right-txt {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.info-json-text {
    margin-bottom: 10px;
    display: flex;
}
.info-json-text:last-child {
    margin-bottom: 0px;
    display: flex;
}
.product-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #484E66;
    margin-bottom: 10px;
}
.json-text-img {
    width: 70px;
    height: 70px;
    border-radius: 4px;
    margin: 0 10px 10px 0;
}
.json-text-video {
    width: 70px;
    height: 70px;
}
.json-text-title {
    margin-right: 6px;
    white-space: nowrap;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #FF761D ;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border: 2px solid #FF761D ;
    background-color: #fff;
}
.img-divs {
    background: #F1F5F8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 12px 12px 0 12px;
}
.img-div {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 12px 12px 0;
}
.img-div-icon {
    width: 25px;
}
.img-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
}
.upload-div {
    position: relative;
    width: 70px;
    height: 70px;
    margin: 0 12px 12px 0;
}
.upload-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.upload-img {
    width: 70px;
    height: 70px;
    border-radius: 4px;
}
</style>